import { render, staticRenderFns } from "./ContentBreadcrumb.vue?vue&type=template&id=fa8c1120"
import script from "./ContentBreadcrumb.vue?vue&type=script&lang=ts"
export * from "./ContentBreadcrumb.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports